import Analytics from '@popularpays/analytics';

const gtmId = 'GTM-NTCCDV6B';

Analytics.initialize(gtmId);
